














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import FiltroExpedientes from '@/model/filtros/FiltroExpedientes'
import {
  greaterOrEquals,
  maxLength,
  required,
  totalLength,
} from '@/utils/ValidationUtil'

@Component({ components: {} })
export default class FiltrosExpedientes extends Vue {
  @Prop()
  private filtro: FiltroExpedientes

  form(): Vue & { validate: () => boolean; resetValidation(): void } {
    return this.$refs.form as Vue & {
      validate: () => boolean
      resetValidation(): void
    }
  }
  private rules = {
    required,
    maxLength500: maxLength(500),
    length4: totalLength(4),
    greaterOrEquals2021: greaterOrEquals((): number => 2021),
    maxLength6: maxLength(6),
  }
  validate() {
    return this.form().validate()
  }

  resetValidation() {
    this.form().resetValidation()
  }
}
